<template>
  <div id="app">
    <router-view></router-view>
    <footer>
      <div class="footer-container">
        <span class="footer-block">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502001738" data-menu-item-image="0"><span class="footer-icon"><img src="https://cdn.jcdecaux.com.cn/wwwjcdecauxcn/public/styles/jcd_footer_menu_icon/345/public/assets/image/2018/07/ico.png?v=1.0.5" alt="" title=""></span>沪公网安备 31010502001738号</a>
        </span>
        
        <span class="footer-block">
          <a href="https://beian.miit.gov.cn" data-menu-item-image="0">沪ICP备10028414号</a>
        </span>

      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    name: 'app',
  }
</script>

<style lang="scss" scoped>
  .footer-container {
    //text-align: left;
    //margin-left: 50px;
    margin-top: 30px;
  }
  .footer-block {
    margin-right: 30px;

    a {
      color: black;
    }

    a:hover{
      color: black;
      text-decoration: none;
    }
  }
</style>